/**
 * Gets the current date and time in UTC.
 * @function utcNow
 * @returns {Date} The current date and time in UTC.
 */
const utcNow = (): Date => new Date(new Date().toUTCString());

export { utcNow };
